import React from 'react';

import ButtonDropdown from 'components/ButtonDropdown';

import './styles.css';

const RentScheduleExtraOptions = ({
  openCreateCreditNoteModal,
  openCreateInvoiceModal,
  openCreateDraftInvoiceModal,
  openCreateOverpaymentModal,
  scheduleType,
  scheduleId
}) => (
  <div className="RentScheduleExtraOptions">
    <ButtonDropdown title="Schedule options">
      <ButtonDropdown.Option
        onClick={() => openCreateInvoiceModal(scheduleType)}>
        Create an invoice
      </ButtonDropdown.Option>
      <ButtonDropdown.Option
        onClick={() => openCreateDraftInvoiceModal(scheduleType, scheduleId)}>
        Create a draft invoice
      </ButtonDropdown.Option>
      <ButtonDropdown.Option
        onClick={() => openCreateCreditNoteModal(scheduleType)}>
        Create a credit note
      </ButtonDropdown.Option>
      <ButtonDropdown.Option
        onClick={() => openCreateOverpaymentModal(scheduleType)}>
        Create an overpayment
      </ButtonDropdown.Option>
    </ButtonDropdown>
  </div>
);

export default RentScheduleExtraOptions;
